import {useContext, useEffect} from "react";
import { ThemeContext } from "../context/ThemeContext";

const useTenantAssets = () => {
  const { metadata } = useContext(ThemeContext);
  const tenantConfig = {
    oneplacesolar: {
      logos: {
        navbar: "/images/Logo_1.png",
        login: "/images/Logo.png",
        displayName: "One Place Solar",
      }
    },
    reyzap: {
      logos: {
        navbar: "/images/LOGO-07.png",
        login: "/images/LOGO-13.png",
        displayName: "Reyzap",
      }
    },
  };

  const host = metadata?.name || "";

  const match = Object.keys(tenantConfig).find((key) =>
    host.includes(key)
  );

  const config = tenantConfig[match];

  const getLogo = (type = "navbar") => {
    return config?.logos?.[type];
  };
  const title = config?.logos?.displayName || "Reyzap";
  console.log(config, title);
  return { getLogo, title };
};

export default useTenantAssets;